import { render, staticRenderFns } from "./EntryDetails.vue?vue&type=template&id=32216795&scoped=true&"
import script from "./EntryDetails.vue?vue&type=script&lang=js&"
export * from "./EntryDetails.vue?vue&type=script&lang=js&"
import style0 from "./EntryDetails.vue?vue&type=style&index=0&id=32216795&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32216795",
  null
  
)

export default component.exports